// extracted by mini-css-extract-plugin
module.exports = {"splitPanel":"BankCardAmount_splitPanel__H_THK","splitPanelEditable":"BankCardAmount_splitPanelEditable__ULoO8"};